import { useEffect, useState } from "react";
import useSWR from "swr";
import { Save, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Card, btn } from "@/components/common/Ornament";

export default function DisclaimerTab() {
  const { data, mutate } = useSWR("/content");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (data) setText(data.disclaimer);
  }, [data]);

  const save = async () => {
    setBusy(true);
    try { const { data: d } = await api.put("/admin/content", { disclaimer: text }); mutate(d, false); toast.success("Disclaimer saved"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Card eyebrow="Required Before Entry" title="Disclaimer Text" testId="admin-disclaimer">
      <p className="text-sm text-slate-600 mb-3">Shown full-screen after every login and in the footer link. Changes apply to the next acknowledgment.</p>
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={14} className="w-full rounded-md border border-[#E2DCD2] bg-white p-4 text-sm leading-relaxed focus:outline-none focus:border-[#C59B27]" data-testid="admin-disclaimer-textarea" />
      <button onClick={save} disabled={busy || !text.trim()} className={btn.gold + " mt-4"} data-testid="admin-disclaimer-save-btn">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Save disclaimer</button>
    </Card>
  );
}
